const data = {
  czechLanguage: "czech",
  englishLanguage: "english",
  "footer.version": "web application version {version}",
  "footer.rights": "{year} © DHL International GmbH. All rights reserved.",
  "countries.loadError": "There is an error within loading of countries",
  "countries.label": "Country",
  "countries.message": "Please select a country!",
  "countries.placeholder": "select a country",
  "messages.pdfExport": "in pdf format",
  "messages.xlsxExport": "in xlsx format",
  "exportButton.question":
    "You have no {entity} selected, do you want to export all loaded {entity}?",
  "messages.yes": "Yes",
  "messages.no": "No",
  "messages.dateTimeItem": "Select date and time",
  "messages.dateItem": "Select date",
  "messages.input.required": "This information is mandatory!",
  "messages.input.email": "Please enter a valid email!",
  "messages.input.variableSymbol":
    "Variable symbol must contain only numbers and have maximum length of 10!",
  "messages.input.unCode":
    "UN code must contain only numbers and have maximum length of 4!",
  "messages.input.companyId":
    "Registration number must have maximum length of 18!",
  "messages.input.companyId.czech":
    "Registration number must contain only numbers and have maximum length of 12!",
  "messages.input.nationalId": "National ID is not in the correct format.",
  "messages.input.companyIdOrNationalId":
    "Enter correct Company ID or National ID.",
  "messages.input.licenceIso": "Enter prefix in the correct format!",
  "messages.input.licenceGs1": "Enter prefix in the correct format!",
  "messages.input.zipCode": "Enter zip code in the correct format!",
  "messages.input.number": "Enter valid number!",
  "messages.input.phoneNumber": "Enter valid phone number!",
  "messages.input.range":
    "The permitted range of values from {min} to {max} has been exceeded!",
  "messages.loadError": "Reload",
  "messages.loadTable.error": "An error occured while loading {what}.",
  "messages.loadTable.noData": "no data",
  "messages.select.notAll": "Unmark all records",
  "messages.select.all": "Mark all records",
  "messages.stateIcon.valid": "All entered values are correct.",
  "messages.stateIcon.invalid":
    "This block contains missing or incorrect entered values.",
  "messages.filter.button": "Filter",
  "messages.navbar.home": "Go to the main page",
  "messages.logout": "Logout",
  "messages.userMenu": "User menu",
  "messages.close": "Close",
  "messages.save": "Save",
  "messages.unknown": "unknown",
  "messages.filter": "Filter",
  "messages.pages": "Page {from} of {to}",
  "import.result": "Result of the import",
  "import.success": "The import was successful.",
  "import.error": "There was a processing error!",
  "import.saved": "Successfully saved!",
  "import.not.saved":
    "There was a problem when importing the pricelist - {error}!",
  "import.title": "File without name",
  "import.title.code": "File {code}",
  "login.username.error": "Please enter username!",
  "login.username": "username",
  "login.password": "password",
  "login.password.error": "Please enter password!",
  login: "Login",
  "messages.accessDenied": "Access denied",
  "messages.accessDenied.message":
    "You don't access rights to this web application. If you think you should have it, please contact DHL ITS CZ.",
  "crud.create": "{what} successfully created.",
  "crud.createError": "An error occurred while creating the {whatError}!",
  "crud.edit": "{what} successfully edited.",
  "crud.editError": "An error occurred while editing the {whatError}!.",
  "crud.delete": "{what} deleted successfully.",
  "crud.deleteError": "An error occurred while deleting the {whatError}!",
  "session.securityLogout": "Security logout!",
  "session.authorizationError": "You are not allowed to do that operation!",
  "messages.warning": "Warning",
  "messages.error": "An error occured while sending data!",
  "session.logout": "You've been logged out!",
  "session.loginError": "Server is not respoding, try again later please.",
  "welcome.title":
    "Welcome to the online communication tool with DHL Freight CZ",
  "welcome.text":
    "DHL Freight now offers registered customers the option to enter into a freight contract online, without having to contact customer service. This makes ordering your shipments easier and more convenient than ever before. Simply register and start sending your shipments through our completely digital platform.",
  "welcome.help":
    "In case of a problem, contact customer service at +420 239 018 222 or by e-mail: DHLFreight.CZ@dhl.com.",
  registration: "Registration",
  "registration.new": "New registration",
  "registration.old": "Developed registration",
  "registration.sent": "Submitted registration",
  "registration.security.write": "Send",
  "registration.security.wrong": "Incorrect password was given.",
  "registration.security.password": "Password",
  "registration.security.password.message": "Enter password",
  "registration.steps.form": "Details",
  "registration.steps.consents": "Consents",
  "registration.steps.end": "Send",
  "registration.description": "Registration of the new client",
  "registration.description.old": "Continue with registration in progress",
  "registration.description.sent": "View submitted registration",
  "registration.detail.goBack": "Go back",
  "registration.person.physical": "Natural person",
  "registration.person.legal": "Legal entity",
  "registration.companyIdOrNationalId": "Company ID / National ID",
  "registration.companyId": "Company ID",
  "registration.companyId.unknown":
    "Dear customer, automatic registration is only allowed for entities based in the Czech Republic. To register, please call DHL Freight CZ Customer Service at 239 018 222 or email DHLFreight.CZ@dhl.com.",
  "registration.representedBy": "Represented by",
  "registration.representedBy.empty":
    "Enter first name and last name of the represented person.",
  "registration.municipal": "At",
  "registration.municipal.placeholder": "Municipality of Ostrava",
  "registration.registeredAt.legal": "Registered in the Commercial Register",
  "registration.registeredAt.physical": "Registered in the Trade Register",
  "registration.registeredAt.empty": "Enter value please",
  "registration.registeredAt.type": "Registered in the",
  "registration.registeredAt.type.commercialRegister": "Commercial Register",
  "registration.registeredAt.type.tradeRegister": "Trade Register",
  "registration.registeredAt.municipalCourt": "Municipal Court",
  "registration.registeredAt.regionalCourt": "Regional Court",
  "registration.registeredAt.section": "section",
  "registration.registeredAt.liner": "liner",
  "registration.bank.national": "czech bank account format",
  "registration.bank.international": "international bank account - IBAN",
  "registration.bank.accountPrefix": "Prefix",
  "registration.bank.accountPrefix.invalid": "Prefix is invalid",
  "registration.bank.account": "Account code",
  "registration.bank.account.empty": "Account code is mandatory",
  "registration.bank.account.invalid": "Account code is invalid",
  "registration.bank.code": "Bank code",
  "registration.bank.code.empty": "Select bank code please",
  "registration.bank.code.loadError": "An error occured while loading banks.",
  "registration.bank.iban": "IBAN",
  "registration.bank.iban.empty": "IBAN is required",
  "registration.bank.iban.invalid": "IBAN is invalid",
  "registration.address": "Address",
  "registration.address.home": "Permanent residence",
  "registration.bank": "Bank accounts",
  "registration.address.invoice": "Invoice address",
  "registration.address.pickup": "Pickup address",
  "registration.contacts": "Contacts",
  "registration.contacts.principal": "Principal",
  "registration.contacts.principal.contact": "Name and surname",
  "registration.contacts.principal.email": "Email",
  "registration.contacts.principal.phone": "Phone",
  "registration.contacts.email.invoice": "Email for electronic invoicing",
  "registration.contacts.email.business": "Email for business communications",
  "registration.contacts.contact.business": "Contact for business communications",
  "registration.contacts.phone.business": "Phone for business communications",
  "registration.contacts.email.tracking": "Email for tracking shipments",
  "registration.products": "Products",
  "registration.products.ecdb2b": "DHL Freight EuroConnect Domestic",
  "registration.products.ecdb2b.info": "B2B / Less-than-Truck-Load (LTL)",
  "registration.products.ecdb2b.text":
    "Our Domestic Less Than Truck Load (LTL) product for palletized and groupage shipments offers superior quality, highly reliable, cost efficient door-to-door connections.",
  "registration.products.ecdb2b.item.0": "Shipment up to 800 kg / 3000 kg",
  "registration.products.ecdb2b.item.1": "Maximum weight per shipment: 3000 kg",
  "registration.products.ecdb2b.item.2": "Maximum weight per item: 800 kg",
  "registration.products.ecdb2b.item.3":
    "Maximum dimensions per item: 400 cm (L) x 220 cm (W) x 220 cm (H)",
  "registration.products.ecdb2b.item.4":
    "Daily shipments connecting  major cities and areas in Czech Republic",
  "registration.products.ecdb2b.item.5":
    "Online Track and Trace with event notification and delivery details",
  "registration.products.ecdb2b.item.6":
    "Easy booking process via e-booking tools",
  "registration.products.ecdb2b.item.7": "Collection and delivery on wheels",
  "registration.products.ecdb2c": "DHL Freight Home Delivery Domestic",
  "registration.products.ecdb2c.info": "B2C / Less-than-Truck-Load (LTL)",
  "registration.products.ecdb2c.text":
    "Our Domestic Less Than Truck Load (LTL) product for palletized and groupage shipments offers superior quality, highly reliable, cost efficient door-to-door connections.",
  "registration.products.ecdb2c.item.0": "Shipment up to 800 kg / 3000 kg",
  "registration.products.ecdb2c.item.1": "Maximum weight per shipment: 3000 kg",
  "registration.products.ecdb2c.item.2": "Maximum weight per item: 800 kg",
  "registration.products.ecdb2c.item.3":
    "Maximum dimensions per item: 400 cm (L) x 220 cm (W) x 220 cm (H)",
  "registration.products.ecdb2c.item.4":
    "Daily shipments connecting  major cities and areas in Czech Republic",
  "registration.products.ecdb2c.item.5":
    "Online Track and Trace with event notification and delivery details",
  "registration.products.ecdb2c.item.6":
    "Easy booking process via e-booking tools",
  "registration.products.ecdb2c.item.7": "Collection and delivery on wheels",
  "registration.products.eci": "DHL Freight EuroConnect International",
  "registration.products.eci.info": "Reliable & Cost Effective LTL",
  "registration.products.eci.text":
    "Our Less-than-Truck-Load (LTL) network product for palletized and non-palletized groupage shipments offers superior quality, highly reliable, cost efficient door-to-door connections across Europe.",
  "registration.products.eci.item.0": "Shipments up to 2,500 kg",
  "registration.products.eci.item.1": "Maximum weight per item: 1,500 kg",
  "registration.products.eci.item.2":
    "Maximum dimensions per item: 240 cm (L) x 220 cm (W) x 220 cm (H). For items that exceed these measurements, please contact Customer Service.",
  "registration.products.eci.item.3": "Liability per CMR",
  "registration.products.eci.item.4":
    "Defined lead times based on origin/destination",
  "registration.products.eci.item.5":
    "Daily shipments connecting major European business centers",
  "registration.products.eci.item.6":
    "Online Track and Trace with event notification and delivery details",
  "registration.products.eci.item.7":
    "Easy booking process via e-booking tools",
  "registration.products.eci.item.8": "Collection and delivery on wheels",
  "registration.products.eri": "DHL Freight Eurapid",
  "registration.products.eri.info": "Day Definite LTL",
  "registration.products.eri.text":
    "Our day-definite, pan-European door-to-door priority service for palletized and non-palletized groupage shipments, including dedicated customer service.",
  "registration.products.eri.item.0": "Shipments up to 2,500 kg",
  "registration.products.eri.item.1": "Maximum weight per item: 1,000 kg",
  "registration.products.eri.item.2":
    "Maximum dimensions per item: 240 cm (L) x 120 cm (W) x 220 cm (H)",
  "registration.products.eri.item.3": "Dedicated customer service",
  "registration.products.eri.item.4":
    "Committed daily departure/scheduled arrival dates",
  "registration.products.eri.item.5":
    "Daily pick-up service/prioritized handling",
  "registration.products.eri.item.6": "Same day pick-up at defined zip codes",
  "registration.products.eri.item.7":
    "Proactive notification and online Track and Trace",
  "registration.products.eri.item.8":
    "Same day Information of Delivery (IOD) and 24 hour electronic Proof of Delivery (ePOD)",
  "registration.products.warn": "You must select at least one product!",
  "registration.address.invoice.same": "same as address",
  "address.name": "Name",
  "address.name.empty": "Enter name please.",
  "address.street": "Street",
  "address.street.empty": "Enter street please",
  "address.streetNumber": "Street number",
  "address.streetNumber.empty": "Enter street number please.",
  "address.city": "City",
  "address.city.empty": "Enter city please.",
  "address.zipCode": "Zip",
  "address.zipCode.empty": "Enter zip please.",
  "address.contactPerson": "Contact person",
  "address.contactPerson.empty": "Enter contact person please.",
  "address.contactPerson.firstName": "First name",
  "address.contactPerson.firstName.empty": "Enter first name please.",
  "address.contactPerson.lastName": "Last name",
  "address.contactPerson.lastName.empty": "Enter last name please.",
  "address.contactPhone": "Contact phone",
  "address.contactPhone.empty": "Enter contact phone please.",
  "address.preselection.loadError":
    "An error occured while loading preselections.",
  "address.contactEmail": "Contact email",
  "address.contactEmail.empty": "Enter contact email please.",
  "address.validation.zipCode.five":
    "Enter the postal code in five-digit format",
  "address.validation.zipCode.fiveCountry":
    "Enter the postal code in five-digit format with country code prefix (XX-)",
  "address.validation.zipCode.four":
    "Enter the postal code in four-digit format",
  "address.validation.zipCode.fourCountry":
    "Enter the postal code in four-digit format with country code prefix (XX-)",
  "address.validation.zipCode.poland":
    "Enter the postal code in correct format (XX-XXX)",
  "address.validation.zipCode.gbAndDe":
    "Enter the postal code in correct format",
  "address.validation.zipCode.alphanumeric":
    "Enter the postal code in alphanumeric format!",
  "address.validation.zipCode.others":
    "Enter the postal code in correct format for the selected country",
  "address.validation.phone.eight": "Enter the phone number of 8 digits!",
  "address.validation.phone.nineTen":
    "Enter the phone number of 9 or 10 digits!",
  "address.validation.phone.nine":
    "Enter the phone number in nine-digit format!",
  "address.validation.phone.czech": "Enter valid Czech mobile phone number.",
  "address.validation.phone.ten": "Enter the phone number of 10 digits!",
  "address.validation.phone.eleven":
    "Enter the phone number of 10 or 11 digits!",
  "address.validation.phone.tenMore":
    "Enter the phone number of 10, 11, 12, 13, 14 digits!",
  "address.validation.phone.others":
    "Enter the phone number in the correct format for the selected country!",
  "registration.furtherInformation": "Further information",
  "registration.maturity": "Maturity of invoice",
  "registration.maturity.weekly": "Weekly",
  "registration.maturity.monthly": "Monthly",
  "registration.placeOfSign": "Place of signing",
  "registration.placeOfSign.place": "address",
  "registration.placeOfSign.home": "permanent residence",
  "registration.placeOfSign.different": "different",
  "registration.terms.here": "current terms and conditions for printing",
  "registration.terms":
    "I confirm that I have read the terms and conditions and fully agree with them.\n\nYou also agree that by registering for the Customer App and acceptance of these Terms and Conditions fully supersedes any prior arrangements, agreements or contracts between the Customer and DHL, relating to a similar or identical subject matter (in particular, service transportation) as set out in this Customer Application.",
  "registration.terms.mustHave": "You must agree to the terms and conditions.",
  "registration.personalData": "I agree to the processing of personal data",
  "registration.personalData.mustHave":
    "You must consent to the processing of personal data.",
  "registration.summary.title":
    "Registration is almost complete, now confirm your registration to DHL by clicking the button below and watch for an email with more information.",
  "registration.back": "back",
  "registration.continue": "continue",
  "registration.sms.label": "Phone to confirm registration",
  "registration.sms.message": "Enter valid phone number please!",
  "registration.sms.getCode": "Send code",
  "registration.sms.getCode.another": "Resend code",
  "registration.sms.code": "Confirmation code from SMS",
  "registration.sms.success": "Code was successfully sent to your phone.",
  "registration.sms.error":
    "The SMS limit has been exceeded, please try again later.",
  "registration.sms.error.extended":
    "Dear customer, you have exceeded the limit in entering verification SMS. To complete your registration, please call DHL Freight CZ Customer Service at 239 018 222 or email DHLFreight.CZ@dhl.com.",
  "registration.sms.error.smsError":
    "Dear customer, it is currently not possible to send confirmation sms. If the problem persists, please call DHL Freight CZ Customer Service at 239 018 222 or email DHLFreight.CZ@dhl.com.",
  "registration.submit": "submit registration",
  "registration.submit.sms":
    "you must first confirm your phone to submit registration",
  "registration.submit.title": "submit registration to DHL",
  "registration.submit.result":
    "The registration has been successfully registered within DHL.",
  "registration.submit.result.error":
    "An error occured while sending registration.",
  "registration.sms.phone.error": "Enter valid Czech mobile phone number.",
  "registration.validate": "validate form",
  "registration.validate.title": "checks the data in the form",
  "registration.valid": "Form is valid and ready to send!",
  "registration.invalid": "Form is not valid!",
  "registration.save": "save data",
  "registration.save.title": "saves the form for later completion",
  "registration.save.result": "Registration was successfully saved.",
  "registration.save.result.error":
    "An error occured while saving registration.",
  "registration.save.result.sms": "Invalid SMS confirmation code.",
  "registration.drop": "delete registration",
  "registration.drop.title": "deletes a previously saved registration",
  "registration.sent.info":
    "The registration has already been sent to DHL, so it cannot be edited.",
  "registration.sent.insolvency":
    "To complete your registration, please call DHL Freight CZ Customer Service at 239 018 222 or email DHLFreight.CZ@dhl.com.",
};

export default data;
